<template>
<div class="cont">
  <div class="toutu">
    <img src="../../assets/1-1Z523164641438.jpg" /></div>
  <div class="div_t">
    <div style="text-align: center;">
        <img class="gyxltitle" src="../../assets/gyxltitle.jpg" />
	<p class="title_xl">干燕系列</p>
</div>
<div class="center" style="text-align: center;">

	<span class="title_l">印尼直供 ● 安全保障<br />
	<br />
	<img alt="" src="../../assets/1-1Z524105KWX.jpg" width="100%" /><br />
	<br />
    <span class="title_m">
	燕窝好不好先看源头<br />
燕铺干燕系列-只选产量不足10%、<br />
唾液酸含量高于11%的印尼极轻毛燕原料<br />
    </span>
	<br />
	<img alt="" src="../../assets/1-1Z60413434YB.jpg" width="100%" /><br />
	<br />
	 <span class="title_m">
燕屋源头经官方认证<br />
来自燕窝产量更多<br />
营养价值更高的印度尼西亚---自有燕屋<br />
原产地直供<br />
    </span>
	<br />
	<img alt="" src="../../assets/1-1Z604134549109.jpg" width="100%"/></span><br />
	<br />
	<span class="title_m">纯手工干挑毛\深入洁净每一根燕丝\洁净度很高<br />
<b>追求天然：</b><br />
坚持0漂白0刷胶0添加<br />
色泽天然、底座自然、燕丝清晰</span><br />
	<br />
	<span style="font-size:20px;"><img alt="" src="../../assets/1-1Z6041346305A.jpg"  width="100%"/></span><br />
	<br />
	<br />
	<p class="title_m">工厂每个工作人员需严格按照卫生标准穿戴整齐<br />
制服、口罩、头套、手套都是标配<br />
严格执行食品安全管理体系（HACCP)，高于行业标准

	</p>
	<br />
	<p class="title_xxl">○燕铺<span>·</span>干燕盏○</p>
	<br />
	<span class="title_s"><img alt="" src="../../assets/1-1Z604142533435.jpg"  width="100%"/><br />
	<br />
	<p class="title_x"><img src="../../assets/zheng.jpg"/>印尼原产地直供原料，品质保障。一盏一码，正品保证、安全保障。</p>
	<p class="title_x"><img src="../../assets/fa.jpg"/>燕铺干燕，泡发率达8—10倍（重量比重）。</p>
	<p class="title_x"><img src="../../assets/jia.jpg"/>燕窝一站式服务，自有燕屋，真正实现直销，无中间商赚差价！同样  
    的品质更低的价格，同样的价格更高的品质！</p>
	<br />
	<img alt="" src="../../assets/1-1Z5231I63Q22.jpg" width="100%"/><br />
	<br />
	<p class="title_x"><img src="../../assets/ico3.jpg"/>呈现燕窝天然的通透色泽和挑毛后的自然缝隙，0刷胶、0添加、0漂白。</p>
	<p class="title_x"><img src="../../assets/ico4.jpg"/>完整的燕盏原料，严格标准的纯手工挑毛，泡发炖煮不用二次挑毛。</p>
	<p class="title_x"><img src="../../assets/ico5.jpg"/>好品质燕窝呈现的是天然的米白色或米黄色，散发着自然的气息。</p>
    <br />
	<img alt="" src="../../assets/1-1Z5231IZNX.jpg" width="100%" /><br />
</span>

</div>

<div>
</div>

  </div>
</div>
</template>

<script>
	
export default {
  name: 'starGyxl',
  data () {
    return {
      
    }
  },
  methods:{
			
		}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.toutu {
    width: 1120px;
    margin: auto;
}
.title_x{ line-height: 60px; width: 900px; text-align: left; margin: 0 auto;}
.title_x img{ vertical-align: middle; margin-right: 20px}
.title_xl{ font-size: 45px; background: url(../../assets/gyxlxl.jpg) no-repeat center bottom;    line-height: 110px;  padding-bottom: 48px;}
.title_xxl{ font-size: 32px; background: url(../../assets/gyxlxl.jpg) no-repeat center top;      line-height: 110px;  padding-top: 60px;}
.title_l{ font-size: 32px;}
.title_s{ font-size: 20px;}
.gyxltitle{width:780px}
.div_t {
    width: 1120px;
    margin: auto;
    margin-top: 84px;
    margin-bottom: 86px;
}
.toutu img {
    width: 100%;
}

.cont {
    width: 1120px;
    margin: 0 auto;
    height: 100%;

}

.div_t_div {
    width: 1120px;
    height: 500px;
    position: relative;
}

.div_t_div_img1 {
    width: 500px;
    position: absolute;
}

.div_t_div_img2 {
    position: absolute;
    margin-left: 400px;
    top: 62px;
    z-index: 1;
    height: 280px;
    width: 700px;
}

.text1 {
    position: absolute;
    margin-left: 580px;
    top: 94px;
    z-index: 3;
    width: 500px;
}

.text1 li {
    display: block;
    font-size: 26px;
    letter-spacing: 3px;
    color: #1b1b1b;
    margin-left: 0px;
}

.hrs {
    height: 1px;
    border: none;
    border-top: 1px solid #35b597;
    width: 426px;
    margin-left: 0px;
    margin-top: 16px;
    float: left;
}

.text1_p {
    font-size: 16px;
    text-indent: 2em;
    float: right;
    margin-right: 50px;
    margin-top: 10px;
    line-height: 39px;
    color: #1b1b1b;
    letter-spacing: 1px;
}

.div_c {
    width: 1120px;
    margin: 0 auto;
    margin-top: 0px;
    height: 500px;
    position: relative;
}

.div_c_img1 {
    width: 500px;
    margin-left: 620px;
    position: absolute
}

.div_c_img2 {
    position: absolute;
    top: 50px;
    z-index: 1;
    height: 280px;
    margin-left: 50px;
    width: 700px;
}

.text2 {
    position: absolute;
    /*margin-left: 100px;*/
    top: 82px;
    z-index: 3;
    width: 500px;
}

.text2_li {
    display: block;
    font-size: 26px;
    letter-spacing: 5px;
    color: #1b1b1b;
}

.text2_p {
        font-size: 16px;
    text-indent: 2.3em;
    line-height: 39px;
    color: #1b1b1b;
    margin-top: 32px;
    margin-left: 0px;
    letter-spacing: 3px;
}
.title_m{ font-size: 20px; line-height: 50px;}
@media(max-width: 750px) {
   .cont{width:100%; margin: 0 auto;}
   .title_m{ font-size: 26px;line-height: 68px;}
   .toutu{ width: 100%; overflow: hidden}
   .toutu img{ width: 120%; margin-left: -10%;}
   .div_t{ width: 690px;}
   .center{ overflow: hidden; width: 100%;}
   .center img{ max-width: 100%;}
   .title_l{ font-size: 32px;}
   .title_s{ font-size: 26px}
   .title_x{ width: 690px;}
   .gyxltitle{width:690px}
}
</style>



// WEBPACK FOOTER //
// src/components/mystar/gyxl.vue